export default {
  index: [
    {
      path: '/freshtype',
      component: resolve => require(['./freshtypeIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/commoditytype/_router.js